/**
 * Qué se puede vender dónde, para lo que se enseña en pantalla.
 *
 * Es el reflejo de `backend/src/services/compatibilidad.service.js`, que es la
 * autoridad: quien impide publicar es el servidor. Aquí solo sirve para avisar
 * antes — para que no importes algo que luego no vas a poder publicar en la
 * tienda que tienes conectada. Si cambias la regla, cambia las dos.
 *
 * eBay no prohíbe comprar en otro marketplace: prohíbe que su marketplace se
 * use para revender lo comprado en otro. En tu propia tienda no hay tal
 * restricción.
 */

export const TIPO_DE_FUENTE = {
    cj: 'mayorista',
    amazon: 'minorista',
    aliexpress: 'marketplace',
    ebay: 'marketplace'
};

const ADMITE = {
    ebay: ['mayorista'],
    shopify: ['mayorista', 'minorista', 'marketplace'],
    woocommerce: ['mayorista', 'minorista', 'marketplace']
};

export function tipoDeFuente(source) {
    return TIPO_DE_FUENTE[String(source || '').toLowerCase()] || null;
}

export function sePuedePublicar(source, platform) {
    const tipo = tipoDeFuente(source);
    const admitidos = ADMITE[String(platform || '').toLowerCase()];

    if (!admitidos || !tipo) return { permitido: false, tipo };
    return { permitido: admitidos.includes(tipo), tipo };
}

/**
 * Los destinos que hoy saben publicar de verdad.
 *
 * Espejo de las filas CON operaciones de `backend/src/services/destino.service.js`.
 * Allí Shopify y WooCommerce están declarados con `operaciones: {}` —se pueden
 * nombrar, no se puede publicar en ellos— y su botón de conectar está apagado.
 *
 * Sin esta lista, la pantalla de búsqueda decía «publicable en shopify,
 * woocommerce» sobre un producto de Amazon: dos tiendas que no se pueden
 * conectar. Señalar una salida que no existe es peor que no señalar ninguna,
 * porque manda a buscarla.
 *
 * Cuando una de las dos reciba sus operaciones, entra aquí.
 */
const PUBLICAN_HOY = ['ebay'];

/**
 * Dónde se puede mandar de verdad un producto de esta fuente, hoy.
 *
 * Devuelve solo destinos que existen y publican. Si la respuesta es vacía, la
 * pantalla debe decir que no hay ninguno, no callarse.
 */
export function destinosPosibles(source) {
    const tipo = tipoDeFuente(source);
    if (!tipo) return [];
    return Object.entries(ADMITE)
        .filter(([plataforma, admitidos]) => admitidos.includes(tipo) && PUBLICAN_HOY.includes(plataforma))
        .map(([plataforma]) => plataforma);
}

export default { TIPO_DE_FUENTE, tipoDeFuente, sePuedePublicar, destinosPosibles };
